import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect, useMemo } from 'react';

import { SocketContext } from '../providers/SocketProvider/SocketProvider';

const STALE_TIME = 10 * 60 * 1000; // 10 minutes

const useVotes = (gameId: string, slideId: string, tenantId: string) => {
  const { gameAPI } = useContext(SocketContext);
  const queryClient = useQueryClient();

  const queryKey = useMemo(() => ['votes', tenantId, gameId, slideId], [
    tenantId,
    gameId,
    slideId,
  ]);

  useEffect(() => {
    if (!gameAPI || !gameId || !slideId || !tenantId) return;

    const sub = gameAPI.game
      .subscribeVotes({ gameId, slideId, tenantId })
      .subscribe(({ count }) => {
        queryClient.setQueryData<number>(queryKey, count);
      });

    return () => {
      sub.unsubscribe();
    };
  }, [gameAPI, gameId, slideId, tenantId, queryClient, queryKey]);

  const { data: count } = useQuery<number>({
    queryKey,
    queryFn: () => Promise.resolve(0),
    staleTime: STALE_TIME,
    enabled: Boolean(gameAPI && gameId && slideId && tenantId),
  });

  return {
    count: count ?? 0,
  };
};

export default useVotes;
